<template>
  <div>
    <b-form-group label="Redes" class="">
      <div class="row">
        <div
          v-for="(network, index) in  networkConfigData"
          :key="index"
          class="col-4"
        >
          <div class="network-data rounded p-1">
            <div class="d-flex justify-content-between align-items-center" style="margin-bottom: 5px;">
              <p class="mb-0 lead">
                <feather-icon
                  icon="WifiIcon"
                  size="15"
                  style="margin-right: 5px;"
                />
                <span class="font-weight-bolder h5">
                  Red {{ index + 1 }} ({{ networkInterfaceLabel(network.InterfaceLabel) }})
                </span>
              </p>
              <feather-icon
                class="text-primary"
                role="button"
                icon="SettingsIcon"
                size="18"
                v-b-tooltip.hover
                title="Configurar"
                @click="$emit('select-network', network)"
              />
            </div>
            <p class="font-italic font-weight-light d-flex align-items-center mb-0">
              <feather-icon
                icon="CpuIcon"
                size="16"
                style="margin-right: 5px;"
              />
              {{ network.InterfaceType }}
            </p>
            <table class="table table-sm table-bordered my-1">
              <colgroup>
                <col style="width: 50%">
                <col style="width: 50%">
              </colgroup>
              <tr>
                <th class="font-weight-normal">
                  Conecatado
                </th>
                <td class="text-center">
                  <feather-icon
                    :icon="(network.LinkStatus === 'Connected') ? 'CheckCircleIcon' : 'XCircleIcon'"
                    :class="(network.LinkStatus === 'Connected') ? 'text-success' : 'text-danger'"
                    size="18"
                  />
                </td>
              </tr>
              <tr>
                <th class="font-weight-normal">
                  Gateway default
                </th>
                <td class="text-center">
                  <feather-icon
                    :icon="(network.IsDefaultGateway) ? 'CheckCircleIcon' : 'XCircleIcon'"
                    :class="(network.IsDefaultGateway) ? 'text-success' : 'text-danger'"
                    size="18"
                  />
                </td>
              </tr>
            </table>
            <b-tabs fill>
              <b-tab title="IPV4">
                <dl class="row mb-0">
                  <dt class="col-sm-6 h5">Tipo</dt>
                  <dd class="col-sm-6">{{ network.IPv4Type }}</dd>
                  <dt class="col-sm-6 h5">IP</dt>
                  <dd class="col-sm-6">{{ network.IPv4Address }}</dd>
                  <dt class="col-sm-6 h5"> Gateway</dt>
                  <dd class="col-sm-6">{{ network.IPv4Gateway }}</dd>
                  <dt class="col-sm-6 h5">Mascara de subred</dt>
                  <dd class="col-sm-6">{{ network.IPv4SubnetMask }}</dd>
                  <dt class="col-sm-6 h5">Dirección MAC</dt>
                  <dd class="col-sm-6">{{ network.MACAddress }}</dd>
                </dl>
              </b-tab>
              <b-tab title="IPV6">
                <dl class="row mb-0">
                  <dt class="col-sm-6">Habilitado</dt>
                  <dd class="col-sm-6">
                    <feather-icon
                      :icon="(network.IPv6Enable === 'Connected') ? 'CheckCircleIcon' : 'XCircleIcon'"
                      :class="(network.IPv6Enable === 'Connected') ? 'text-success' : 'text-danger'"
                      size="18"
                    />
                  </dd>
                  <dt class="col-sm-6 h5">Tipo</dt>
                  <dd class="col-sm-6">{{ network.IPv6Type }}</dd>
                  <dt class="col-sm-6 h5">IP</dt>
                  <dd class="col-sm-6">{{ (network.IPv6Address) ? network.IPv6Address : '-' }}</dd>
                  <dt class="col-sm-6 h5"> Gateway</dt>
                  <dd class="col-sm-6">{{ (network.IPv6DefaultGateway) ? network.IPv6DefaultGateway : '-' }}</dd>
                  <dt class="col-sm-6 h5">Longitud de prefijo</dt>
                  <dd class="col-sm-6">{{ network.IPv6PrefixLength }}</dd>
                </dl>
              </b-tab>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </b-form-group>
    <b-form-group
      v-if="defaultGateway"
      label="Ancho de banda"
      class="my-1"
    >
      <p class="text-center">{{defaultGateway.Bandwidth}}/{{ bandWidthData.max }}</p>
      <div class="d-flex">
        <b-form-input
          type="range"
          class="form-control-range col-11"
          v-model.number="defaultGateway.Bandwidth"
          :min="bandWidthData.min"
          :max="bandWidthData.max"
        />
        <p class="mb-0 col-auto">Mbps</p>
      </div>
    </b-form-group>
    <b-form-group
      label="Puerto de enlace predefinido"
      class="mt-2"
      v-slot="{ ariaDescribedby }"
    >
      <div class="text-center">
        <b-form-radio-group
          id="btn-networks"
          v-model="localNetworkGatewayDefault"
          :options="networkConfigData"
          :aria-describedby="ariaDescribedby"
          button-variant="outline-primary"
          name="radio-btn-outline"
          buttons
          @input="$emit('network-gateway-default-change', $event)"
        />
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  props: {
    bandWidthData: {
      type: Object
    },
    defaultGateway: {
      type: Object
    },
    networkConfigData: {
      type: Array
    },
    networkGatewayDefault:{
      type: String
    }
  },
  setup(props, { emit }) {
    //COMPUTED
    const localNetworkGatewayDefault = computed({
      get: () => props.networkGatewayDefault,
      set: (value) => {
        emit("update:networkGatewayDefault", value);
      }
    });

    //METHODS
    const networkInterfaceLabel = (label) => {
      const labels = {
          All: 'Todo',
          Camera: 'Cámara',
          Viewer: 'Visor',
          iSCSI: 'iSCSI',
          'Wi-Fi': 'Wi-Fi'
      }

      return labels[label];
    }

    return {
      networkInterfaceLabel,

      localNetworkGatewayDefault
    }
  }
}
</script>

<style lang="scss" scoped>
.network-data {
  border: 1px solid rgba(34, 41, 47, 0.2);
}

table.table tr th {
  background-color: #f8f9fa;
}
</style>
